import { Link } from "react-router-dom";
import { Badge, DataTable, Select, money, statusTone, useFilterOptions, useTable } from "./ui";

export default function FloristsPage() {
  const table = useTable("/admin/tables/florists", { sort: "shop_name", dir: "asc" });
  const options = useFilterOptions();

  const columns = [
    { key: "shop_name", label: "Shop", sortable: true, render: (r) => (
      <Link to={`/admin/florists/${r.id}`} className="underline decoration-brass underline-offset-2" data-testid={`florist-link-${r.id}`}>
        {r.shop_name}<span className="block text-xs text-muted">{r.owner_name}</span>
      </Link>
    ) },
    { key: "city", label: "City" },
    { key: "status", label: "Status", sortable: true, render: (r) => (
      <span className="flex gap-1">
        <Badge tone={statusTone(r.status)}>{r.status}</Badge>
        {r.paused ? <Badge tone="warn">paused</Badge> : null}
      </span>
    ) },
    { key: "rating", label: "Rating", sortable: true, render: (r) => <span className="tabular">{r.rating ?? "—"}</span> },
    { key: "acceptance_rate", label: "Acceptance", sortable: true, render: (r) => <span className="tabular">{Math.round((r.acceptance_rate || 0) * 100)}%</span> },
    { key: "on_time_rate", label: "On time", sortable: true, render: (r) => <span className="tabular">{Math.round((r.on_time_rate || 0) * 100)}%</span> },
    { key: "orders", label: "Orders", render: (r) => <span className="tabular whitespace-nowrap">{r.orders} <span className="text-muted text-xs">({r.delivered} delivered)</span></span> },
    { key: "owed_mad", label: "Owed", render: (r) => <span className="tabular whitespace-nowrap">{money(r.owed_mad)} MAD</span> },
    { key: "phone", label: "Contact", render: (r) => <span className="text-xs">{r.phone}</span> },
  ];

  const filters = (
    <>
      <Select testid="florists-filter-city" placeholder="Any city" value={table.params.city_id} onChange={(v) => table.set({ city_id: v })}
              options={options.cities.map((c) => ({ value: c.id, label: c.name }))} />
      <Select testid="florists-filter-status" placeholder="Any status" value={table.params.status} onChange={(v) => table.set({ status: v })}
              options={["active", "suspended", "pending", "onboarding"]} />
      <Select testid="florists-filter-paused" placeholder="Paused or not" value={table.params.paused} onChange={(v) => table.set({ paused: v })}
              options={[{ value: "yes", label: "Paused" }, { value: "no", label: "Taking orders" }]} />
    </>
  );

  return <DataTable table={table} columns={columns} testid="florists-table" name="florists" filters={filters}
                    searchPlaceholder="Shop, owner, phone…" empty="No shop matches those filters." />;
}
